export const MIN_LAYER_SIZE = 20;
export const MIN_FABRIC_IMAGE_SCALE = 0.1;

export const clampInitialImageScale = (scale: number, minimum: number, fitTemplateScale: number): number => {
  return Math.min(fitTemplateScale, Math.max(minimum, scale));
};
